/**
 * VideoMetadata 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * VideoMetadata
 */
export interface VideoMetadata {
  /** 帧率(fps) */
  fps?: number
  /** 视频比特率(bps) */
  bit_rate?: number
  /** 视频编码(h264/h265/vp9/av1) */
  codec?: string
  /** 容器格式(mp4/webm/mov) */
  container_format?: string
  /** 是否包含音频 */
  has_audio?: boolean
  /** 旋转角度(0/90/180/270) */
  rotation_degrees?: number
  /** 宽高比(16:9/4:3) */
  aspect_ratio?: string
}

/**
 * VideoMetadata Schema
 */
export const VideoMetadataSchema: SchemaDefinition = {
  properties: {
    fps: {
      description: '帧率(fps)',
      format: '*int',
      type: 'integer',
      label: '帧率',
    },
    bit_rate: {
      description: '视频比特率(bps)',
      format: '*int',
      type: 'integer',
      label: '视频比特率',
    },
    codec: {
      description: '视频编码(h264/h265/vp9/av1)',
      format: '*string',
      type: 'string',
      label: '视频编码',
    },
    container_format: {
      description: '容器格式(mp4/webm/mov)',
      format: '*string',
      type: 'string',
      label: '容器格式',
    },
    has_audio: {
      description: '是否包含音频',
      format: '*bool',
      type: 'boolean',
      label: '是否包含音频',
    },
    rotation_degrees: {
      description: '旋转角度(0/90/180/270)',
      format: '*int',
      type: 'integer',
      label: '旋转角度',
    },
    aspect_ratio: {
      description: '宽高比(16:9/4:3)',
      format: '*string',
      type: 'string',
      label: '宽高比',
    },
  },
  type: 'object',
}
